// extracted by mini-css-extract-plugin
export var indentDescription = "IndentDescription-module--indent-description--3IeT9";
export var indentDescriptionSmallSpacing = "IndentDescription-module--indent-description--small-spacing--2iu03";
export var indentDescriptionContainer = "IndentDescription-module--indent-description-container--nClfk";